"use client"

import PostLink from "@/components/PostLink"
import { formatDateSimple, toImageSrc } from "@/lib/utils"
import Image from "next/image"
import { LatestNewsArticle } from "../types"

interface SidebarArticleProps {
  article: LatestNewsArticle
}

const SidebarArticle = ({ article }: SidebarArticleProps) => {
  return (
    <PostLink
      href={`/${article.slug}`}
      locale={article.locale}
      postId={article.id}
      className="group block flex flex-col sm:gap-2.5 gap-[6px]"
    >
      <div className="relative w-full sm:h-[254px] h-[160px] overflow-hidden rounded-lg">
        {article.imageUrl && (
          <Image
            src={toImageSrc(article.imageUrl)}
            alt={article.title}
            fill
            className="object-cover transition-transform duration-300 group-hover:scale-105 image-hover"
          />
        )}
      </div>

      {/* Content */}
      <div className="flex flex-col">
        {article.categoryName && (
          <div className="text-xs leading-[18.6px] font-bold text-[#1AAF4D]">{article.categoryName}</div>
        )}
        <h2 className="sm:pt-1 pt-[2px] sm:pb-2.5 pb-[5px] sm:text-xl sm:leading-[31px] text-sm leading-[19.6px] font-bold text-[#333] group-hover:text-[#18af4e] transition-colors">
          {article.title}
        </h2>
        <div className="text-base leading-[24.8px] font-medium text-[#333] opacity-70">
          {formatDateSimple(article.publishedAt)}
        </div>
      </div>
    </PostLink>
  )
}

export default SidebarArticle
